import { apiClient } from '../../../api/client'
import { API_ENDPOINTS } from '../../../api/endpoints'
import type { Tenant, TenantFilters, TenantListResponse } from '../types'
import { TenantListResponseSchema, TenantSchema } from '../types/tenant.schema'

export const fetchTenants = async (filters?: TenantFilters): Promise<TenantListResponse> => {
  const params: Record<string, unknown> = {}
  if (filters) {
    if (filters.status) {
      params.status = filters.status
    }
    if (filters.managementType) {
      params.management_type = filters.managementType
    }
    if (filters.demo !== undefined) {
      params.demo = filters.demo
    }
    if (filters.search) {
      params.search = filters.search
    }
    if (filters.ordering) {
      params.ordering = filters.ordering
    }
    if (filters.page) {
      params.page = filters.page
    }
    if (filters.pageSize) {
      params.page_size = filters.pageSize
    }
  }

  const { data } = await apiClient.get<TenantListResponse>(API_ENDPOINTS.TENANTS, { params })

  const parsed = TenantListResponseSchema.safeParse(data)
  if (!parsed.success) {
    console.warn('[fetchTenants] Response shape mismatch:', parsed.error.issues)
  }

  return data
}

export const fetchTenant = async (tenantId: string): Promise<Tenant> => {
  const { data } = await apiClient.get<Tenant>(API_ENDPOINTS.TENANT_DETAIL(tenantId))

  const parsed = TenantSchema.safeParse(data)
  if (!parsed.success) {
    console.warn('[fetchTenant] Response shape mismatch:', parsed.error.issues)
  }

  return data
}
